export const errorMessages = {
  phoneRequired: 'Ошибка! Чтобы отправить вопрос менеджеру введите номер телефона',
  phoneInvalid: 'Неверный формат телефона',
  emailInvalid: 'Неверный формат email',
  telegramInvalid: 'Telegram должен начинаться с "@" и содержать больше 2 символов',
  messageRequired: 'Ошибка! Необходимо ввести вопрос менеджеру',
  messageTooShort: 'Сообщение должно содержать минимум 10 символов',
  messageWithOnlySpaces: 'Сообщение не должно состоять только из пробелов',
  checkboxRequired: 'Вы должны подтвердить согласие',
  emailRequired: 'Ошибка! Чтобы отправить вопрос менеджеру введите email',
  telegramRequired: 'Ошибка! Чтобы отправить вопрос менеджеру введите Telegram',
}

export const phoneValidationRules = {
  RU: { minLength: 10, maxLength: 10 },
  KZ: { minLength: 10, maxLength: 10 },
  AM: { minLength: 8, maxLength: 8 },
  BY: { minLength: 9, maxLength: 9 },
  UZ: { minLength: 9, maxLength: 9 },
  KG: { minLength: 9, maxLength: 9 },
  GE: { minLength: 9, maxLength: 9 },
  TJ: { minLength: 9, maxLength: 9 },
}
